import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MetricCard } from "@/components/ui/MetricCard";
import { formatUsageValue } from "@/utils/formatters";
function UtilizationSummaryCards({ avgDailyUsageValue, avgHourlyUsageValue, isLoading, peakPoint, totalRequests, usageUnit }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4",
        children: [
            /*#__PURE__*/ _jsx(MetricCard, {
                label: "Daily Usage",
                loadingClassName: "w-28",
                isLoading: isLoading,
                value: formatUsageValue(avgDailyUsageValue, usageUnit),
                helperText: "Average per day"
            }),
            /*#__PURE__*/ _jsx(MetricCard, {
                label: "Average / Hour",
                loadingClassName: "w-28",
                isLoading: isLoading,
                value: formatUsageValue(avgHourlyUsageValue, usageUnit),
                helperText: "Across selected period"
            }),
            /*#__PURE__*/ _jsx(MetricCard, {
                label: "Total Requests",
                loadingClassName: "w-20",
                isLoading: isLoading,
                value: totalRequests.toLocaleString(),
                helperText: "Across selected period"
            }),
            /*#__PURE__*/ _jsx(MetricCard, {
                helperText: peakPoint ? formatUsageValue(peakPoint.usageValue, usageUnit) : "No data",
                isLoading: isLoading,
                label: "Peak Interval",
                value: peakPoint ? peakPoint.label : "-"
            })
        ]
    });
}
export { UtilizationSummaryCards };
